import { useReadContract } from "wagmi";
import { PRESALE_CONTRACT_ADDRESS } from "../../../constants";
import { presaleAbi } from "../../../abis/presaleAbi";

export function useLatestBNBPrice() {
  const { data, error, isLoading } = useReadContract({
    address: PRESALE_CONTRACT_ADDRESS,
    abi: presaleAbi,
    functionName: "getLatestPrice",
  });

  if (isLoading) return null;

  if (error) {
    console.log(error);
    return null;
  }

  if (!data) return null;


  const bnbPrice = (Number(data * BigInt(100) / BigInt(10**18)) / 100)

  return { bnbPrice, isLoading };
}
